import React from 'react';
import { Box, Typography } from "@mui/material";

interface Props {
  setEnterNewPassword: React.Dispatch<React.SetStateAction<boolean>>;
  enterNewPassword: boolean;
  successMail: boolean;
  resetUserId:string
}

const EmailSent: React.FC<Props> = ({ setEnterNewPassword, enterNewPassword, successMail,resetUserId }) => {

  return (
    <Box>
      {
        successMail && <div className='successMsg'>
          <img
            src={"success.svg"}
            alt="email"
            style={{ marginBottom: '18px',  margin:'0px' }}
            onClick={() => setEnterNewPassword(!enterNewPassword)}
          />
          <Box sx={{marginRight:'20px'}}>
            <Typography>Success</Typography>
            <Typography sx={{
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '14.52px',
            }}>Your password reset email has been sent successfully!</Typography>
          </Box>

        </div>
      }

      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: "24px",
          mb: '24px',
        }}
      >
        Forgot Password?
      </Typography>
      <img
        src={"email.svg"}
        alt="email"
        style={{ marginBottom: '18px', cursor: 'pointer' }}
        onClick={() => setEnterNewPassword(!enterNewPassword)}
      />
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 700,
          fontSize: "24px",
          mb: '4px',
        }}
      >
        Email Sent
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: "14px",
          color: '#E2E3E3',
          mb: '24px',
          maxWidth: '318px',
          marginInline: 'auto'
        }}
      >
        We have sent an email to <b>{resetUserId}</b> with a link to reset the password.
      </Typography>
    </Box >
  );
}

export default EmailSent;
